import { FormikErrors } from 'formik';
import { createReducer } from '@reduxjs/toolkit';

import {
    ExternalCustomerMapping,
    FormValues,
} from '../../../../components/external-customer-mapping/external-customer-mapping';
import {
    deleteExternalCustomerMapping,
    getExternalCustomerMappings,
    saveExternalCustomerMappings,
    updateStoreExternalCustomerMapping,
} from './customer-external-customer-mapping-actions';

export interface customerExternalCustomerMappingReducerState {
    externalCustomerMapping: ExternalCustomerMapping[];
    requesting: boolean;
    isValid: boolean;
    isDirty: boolean;
    errors: FormikErrors<FormValues>;
    /**
     * The mappings as the server last handed them over (#2159). The list above
     * cannot serve: leaving the tab parks its input right there.
     */
    baseline?: ExternalCustomerMapping[];
}

export const initialCustomerExternalCustomerMappingReducerState: customerExternalCustomerMappingReducerState = {
    externalCustomerMapping: [],
    requesting: false,
    isValid: true,
    isDirty: false,
    errors: {},
};

export const customerExternalCustomerMappingReducer = createReducer(
    initialCustomerExternalCustomerMappingReducerState,
    builder =>
        builder
            .addCase(getExternalCustomerMappings.pending, state => {
                state.requesting = true;
            })
            .addCase(getExternalCustomerMappings.fulfilled, (state, action) => {
                state.externalCustomerMapping = action.payload.map(mapping => ({
                    id: mapping.id,
                    accountId: mapping.supplierId,
                    accountName: mapping.supplierName,
                    externalCustomerId: mapping.externalCustomerId,
                }));
                // The same values, kept apart from the ones the tab edits.
                state.baseline = state.externalCustomerMapping;
                state.requesting = false;
            })
            .addCase(getExternalCustomerMappings.rejected, state => {
                state.requesting = false;
            })
            .addCase(updateStoreExternalCustomerMapping, (state, action) => {
                const { formData, isDirty, isValid, errors } = action.payload;

                state.externalCustomerMapping = formData.mappings;
                state.isDirty = state.isDirty || isDirty;
                state.isValid = isValid;
                state.errors = errors;
            })
            .addCase(saveExternalCustomerMappings.fulfilled, (state, action) => {
                if (action.payload?.result) {
                    state.externalCustomerMapping = action.payload?.result.map(mapping => {
                        return {
                            id: mapping.id,
                            accountId: mapping.supplierId,
                            accountName: mapping.supplierName,
                            externalCustomerId: mapping.externalCustomerId,
                        };
                    });
                    state.baseline = state.externalCustomerMapping;
                    state.isDirty = false;
                    state.isValid = true;
                    state.errors = {};
                }
            })
            .addCase(deleteExternalCustomerMapping.fulfilled, (state, action) => {
                state.externalCustomerMapping = state.externalCustomerMapping.filter(
                    item => item.id !== action.payload
                );
                state.isDirty = true;
            })
);
